import { NomadDB } from '~/db/NomadDB.js';

import type { ImportSchema } from '@/types/schema';

export const getImportsService = (db: NomadDB) => {
  const get = async (params): Promise<ImportSchema> => {
    return await db.imports.get(params);
  };

  const findAll = async (): Promise<ImportSchema[]> => {
    return await db.imports.toArray();
  };

  const findByLibraryBookId = async (
    libraryBookId
  ): Promise<ImportSchema[]> => {
    return await db.imports
      .where('libraryBookId')
      .anyOf(libraryBookId)
      .toArray();
  };

  const findByCollectionWithNoLibraryBookId = async (
    collections: string[]
  ): Promise<ImportSchema[]> => {
    const lParams = collections.map((collection) => ['', collection]);
    return await db.imports
      .where(['libraryBookId+collection'])
      .anyOf(lParams)
      .toArray();
  };

  const clear = async () => {
    return await db.imports.clear();
  };

  const deleteWhere = async (params: object) => {
    return await db.imports.where(params).delete();
  };

  const getImportsSortedByLastUpdated = async (
    libraryBookId: string
  ): Promise<ImportSchema[]> => {
    const items = await db.imports.where({ libraryBookId }).sortBy('updatedAt');
    return items.reverse();
  };

  const save = async (
    collection: CollectionTypes,
    libraryBookId: string = '',
    data: object = null
  ) => {
    const dateCurrent = new Date();
    const debug = false;
    if (debug) {
      dateCurrent.setDate(dateCurrent.getDate() - Math.random() * 30);
    }
    const importationData = {
      collection,
      libraryBookId: libraryBookId ?? '',
      updatedAt: dateCurrent.toISOString(),
      data,
    };
    await db.imports.put(importationData);
  };

  const saveCollections = async (
    collections: CollectionTypes[],
    libraryBookId: string = ''
  ) => {
    const dateCurrent = new Date();

    const params = collections.map((collection) => {
      return {
        collection,
        libraryBookId: libraryBookId ?? '',
        updatedAt: dateCurrent.toISOString(),
      };
    });

    await db.imports.bulkPut(params);
  };

  return {
    get,
    findAll,
    findByLibraryBookId,
    findByCollectionWithNoLibraryBookId,
    clear,
    deleteWhere,
    getImportsSortedByLastUpdated,
    saveCollections,
    save,
  };
};
